export const formattedPhoneNumber = (number: string) => {
    const cleaned = number.replace(/[\(\)\-\s]/g, "");

    const formattedNumber = `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;

    return formattedNumber;
};
